import { createRouter, createWebHistory } from 'vue-router'
import Apps from '@/views/Apps.vue'
import store from '@/store'

const routes = [
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/auth/Login.vue'),
    meta: {
      requiresGuest: true,
      title: `เข้าสู่ระบบ`,
    }
  },
  {
    path: '/',
    name: 'home',
    component: Apps,
    redirect: 'dashboard',
    meta: {
      requiresAuth: true,
      title: `หน้าหลัก`,
      roles: ['admin', 'manager', 'user'],
    },
    children: [
      {
        path: '/profile',
        name: 'profile',
        component: () => import('@/views/Profile.vue'),
        meta: {
          title: `ข้อมูลส่วนตัว`
        }
      },
      {
        path: '',
        name: 'dashboard',
        component: () => import('@/views/Dashboard.vue'),
        meta: {
          title: `หนัาหลัก`
        }
      },
      {
        path: 'users',
        name: 'users',
        component: () => import('@/views/Users.vue'),
        meta: {
          title: `ผู้ใช้งาน`,
          roles: ['admin']
        }
      },
      {
        path: 'admin',
        name: 'admin',
        component: () => import('@/views/Admin.vue'),
        meta: {
          title: `ผู้ดูแลระบบ`,
          roles: ['admin']
        }
      },
      {
        path: 'accesses',
        name: 'accesses',
        component: () => import('@/views/Accesses.vue'),
        meta: {
          title: `แอปพลิเคชันเว็บ`,
          roles: ['admin']
        }
      },
      {
        path: 'roles',
        name: 'roles',
        component: () => import('@/views/Roles.vue'),
        meta: {
          title: `สิทธิผู้ใช้งาน`,
          roles: ['admin']
        }
      },
      {
        path: 'departments',
        name: 'departments',
        component: () => import('@/views/Departments.vue'),
        meta: {
          title: `หน่วยงาน`,
          roles: ['admin']
        }
      },
      {
        path: 'accounts',
        name: "accounts",
        component: () => import('@/views/Accounts.vue'),
        meta: {
          title: `ข้อมูลเจ้าหน้าที่`,
          roles: ['admin']
        }
      },
      {
        path: 'account/:id',
        name: "accountedit",
        component: () => import('@/views/AccountEdit.vue'),
        meta: {
          title: `แก้ไขข้อมูลเจ้าหน้าที่`,
          roles: ['admin']
        }
      },
      {
        path: 'ortherlinks',
        name: "ortherlinks",
        component: () => import('@/views/OrtherLinks.vue'),
        meta: {
          title: `โปรแกรมอื่นๆ`,
          roles: ['admin']
        }
      },
      {
        path: 'modules',
        name: "modules",
        component: () => import('@/views/Modules.vue'),
        meta: {
          title: `ระบบสารสนเทศ`,
          roles: ['admin']
        }
      },
      {
        path: '/groups',
        name: 'GroupsAll',
        component: () => import('@/views/GroupsAll.vue'),
        props: true,
        meta: {
          title: 'กลุ่มงานตามกลุ่มภารกิจ ท้ังหมด'
        }
      },
      {
        path: '/groups/:id',
        name: 'Groups',
        component: () => import('@/views/Groups.vue'),
        props: true,
        meta: {
          title: `กลุ่มงานตามกลุ่มภารกิจ`
        }
      }
    ]
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// router.beforeEach((to, from, next) => {

//   document.title = `${to.meta.title} | ${process.env.VUE_APP_NAME_EN}`

//   if (to.matched.some(record => record.meta.requiresAuth)) {
//     if (!store.getters.isAuthenticated) {
//       next({
//         name: 'login',
//       });
//     }
//     // next();
//     // console.log(store.state.role);
//     if (to.meta?.roles?.includes(store.state.role)) {
//       next()
//     } else {
//       next({ name: "dashboard" })
//     }
//   } else {
//     next();
//   }
// });


router.beforeEach((to, from, next) => {

  document.title = `${to.meta.title} | ${process.env.VUE_APP_NAME_EN}`

  const isAuthenticated = store.getters.isAuthenticated; // หรือวิธีการตรวจสอบสถานะการล็อกอินของคุณ

  if (to.matched.some(record => record.meta.requiresAuth) && !isAuthenticated) {
    // ผู้ใช้ยังไม่ล็อกอิน และพยายามเข้าหน้าต้องการการล็อกอิน
    next({ name: 'login' });
  } else if (to.matched.some(record => record.meta.requiresGuest) && isAuthenticated) {
    // ผู้ใช้ล็อกอินแล้ว และพยายามเข้าหน้าสำหรับผู้ที่ยังไม่ล็อกอิน
    if (to.meta?.roles?.includes(store.state.role)) {
      next()
    } else {
      next({ name: "dashboard" })
    }
  } else {
    next(); // ผ่านได้
  }
});



export default router
